// Turns the row-level preview and paired-file review's teacher-related data
// into the same { severity, message } shape ImportPreview's year-over-year
// Findings already render -- so "N teacher names look new" and "the roster
// says a school moved 40% of a grade" read as one consistent list instead of
// two visually different UI languages bolted together.
//
// Pure and plain-object-in/plain-array-out on purpose: no React, no fetch,
// so it's testable without a component harness (see
// studentImportTeacherFindings.test.js) and reusable if a future screen
// needs the same synthesis.
export const buildTeacherFindings = ({ rowPreview, pairedReview }) => {
  const items = [];

  if (rowPreview && rowPreview.available) {
    const newNames = rowPreview.new_educator_names;
    if (newNames && newNames.length > 0) {
      items.push({
        key: 'new-educators',
        severity: 'new',
        message: `${newNames.length} teacher name(s) don't match an existing teacher and will create a new one: `
          + `${newNames.join(', ')}.`,
      });
    }
  }

  if (pairedReview && pairedReview.available) {
    const gaps = pairedReview.cross_check && pairedReview.cross_check.teachers_missing_from_staff_file;
    if (gaps && gaps.length > 0) {
      items.push({
        key: 'staff-gaps',
        severity: 'warn',
        message: `${gaps.length} teacher(s) named in the roster have no match in the staff file, so they won't `
          + `get a staff photo record from it: ${gaps.join(', ')}.`,
      });
    }

    const { anomalies } = pairedReview;
    if (anomalies) {
      // A failed LLM call must say so, not silently look identical to
      // "checked, nothing found" -- ok is explicitly false only on error.
      if (anomalies.ok === false) {
        items.push({
          key: 'anomaly-error',
          severity: 'warn',
          message: `Could not run the placeholder-name check (${anomalies.error}) -- review the staff/teacher `
            + 'names yourself before continuing.',
        });
      } else if (anomalies.flagged && anomalies.flagged.length > 0) {
        const named = anomalies.flagged.map((flag) => `${flag.name} (${flag.reason})`).join(', ');
        items.push({
          key: 'anomaly-flags',
          severity: 'warn',
          message: 'These staff/teacher names look like placeholders rather than real people -- double-check '
            + `them before continuing: ${named}.`,
        });
      }
    }
  }

  return items;
};
